import "owl.carousel";
import { initSlider } from "./_slider";
import { initPostSlider } from "./_post-slider";

jQuery(function ($) {
    initSlider($);
    initPostSlider($);
});